import { NavLink, useLocation } from 'react-router-dom';
import { LayoutGrid, Building2, Users, ListChecks, LogOut } from 'lucide-react';
import { Logo01Png, Logo03Png } from '@employer-on-record/ui';
import { useAuthStore } from '@/stores/auth';
import { cn, initials } from '@/lib/utils';

const NAV = [
	{ to: '/', label: 'Overview', icon: LayoutGrid, exact: true },
	{ to: '/companies', label: 'Companies', icon: Building2 },
	{ to: '/hr-users', label: 'HR users', icon: Users },
	{ to: '/requests', label: 'All requests', icon: ListChecks }
];

export function Sidebar() {
	const { user, logout } = useAuthStore();
	const location = useLocation();

	const renderItem = (item: typeof NAV[number]) => {
		const active = item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to);
		const Icon = item.icon;
		return (
			<NavLink
				key={item.to}
				to={item.to}
				className={cn(
					'flex items-center gap-2.5 px-2.5 py-2 rounded-md text-[13px] font-medium transition-colors mb-0.5',
					active ? 'bg-sidebar-active text-primary' : 'text-foreground hover:bg-sidebar-hover'
				)}
			>
				<Icon className={cn('h-4 w-4 shrink-0', active ? 'text-primary' : 'text-muted-foreground')} />
				<span className="flex-1">{item.label}</span>
			</NavLink>
		);
	};

	return (
		<aside className="w-60 shrink-0 bg-sidebar border-r flex flex-col sticky top-0 h-screen">
			<div className="px-[18px] py-[14px] border-b flex items-center gap-2">
				<img src={Logo03Png} alt="Canis Major" className="h-7 w-7 shrink-0" />
				<img src={Logo01Png} alt="Canis Major" className="h-6" />
			</div>
			<nav className="flex-1 overflow-y-auto p-2">
				<div className="px-3 pt-3.5 pb-1.5 text-[11px] font-semibold uppercase tracking-wider text-muted-subtle">Control panel</div>
				{NAV.map(renderItem)}
			</nav>
			<div className="px-3 py-3 border-t flex items-center gap-2.5">
				<div className="av av-1 h-8 w-8 rounded-full grid place-items-center font-semibold text-[12px] shrink-0">
					{user?.name ? initials(user.name) : 'CM'}
				</div>
				<div className="flex-1 min-w-0">
					<div className="text-[12px] font-semibold truncate">{user?.name || 'Canis Major'}</div>
					<div className="text-[11px] text-muted-foreground truncate">{user?.email || ''}</div>
				</div>
				<button onClick={logout} title="Sign out" className="p-1.5 rounded text-muted-foreground hover:bg-sidebar-hover hover:text-foreground">
					<LogOut className="h-3.5 w-3.5" />
				</button>
			</div>
		</aside>
	);
}
